import React from 'react';

import Icon from 'components/generic/Icon.component';
import IconStatus from 'components/generic/IconStatus.component';
import { useTranslation } from 'providers/GILT.provider';

import CN from './MessageFailure.module.scss';

const MessageFailure = () => {
  const { t } = useTranslation();
  return (
    <div data-bem="MessageFailure">
      <IconStatus variant="warning">
        <Icon variant="warningCircle" width="l1" />
      </IconStatus>
      <div className={CN.title}>{t('composite.posMessages.errorPart1')}</div>
      <div className={CN.subTitle}>{t('composite.posMessages.errorPart2')}</div>
    </div>
  );
};

// noinspection JSUnusedGlobalSymbols
export default MessageFailure;
